import React from "react";

export default function KpiCard({ label, value, sub, accent, testid, icon: Icon }) {
  return (
    <div
      className="bg-white border border-slate-200 rounded-md p-4 shadow-sm hover:border-slate-300 transition-all"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <div className="text-xs font-medium uppercase tracking-wider text-slate-500">{label}</div>
        {Icon && <Icon className="w-4 h-4 text-slate-400" />}
      </div>
      <div className={`text-2xl sm:text-3xl font-bold font-mono mt-2 ${accent || "text-slate-900"}`}>
        {value}
      </div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </div>
  );
}
